import type {
  CostCenter,
  CostCenterSummary,
} from '@src/models/interfaces/costCenter.interface';

export class CostCenterMapper {
  static toSummary(cc: CostCenter): CostCenterSummary {
    return {
      id: cc.id,
      parentId: cc.parentId ?? null,
      code: cc.code,
      name: cc.name,
      active: Boolean(cc.active),
    };
  }

  static fromApi(raw: CostCenter): CostCenter {
    return {
      id: raw.id,
      organizationId: raw.organizationId,
      parentId: raw.parentId ?? null,
      code: raw.code,
      name: raw.name,
      description: raw.description,
      responsibleUserIds: Array.isArray(raw.responsibleUserIds) ? raw.responsibleUserIds : [],
      active: Boolean(raw.active),
      client: raw.client ?? null,
      contract: raw.contract ?? null,
      contracted: raw.contracted ?? null,
    };
  }
}
